import React from 'react';
import { FaCheck, FaClock, FaLock } from 'react-icons/fa';
import { formatTaipeiMonthDay } from './cardTime';

function PointCircle({ number, state, claimedAt, onSelect }) {
  const labels = {
    claimed: `第 ${number} 點，已完成`,
    available: `第 ${number} 點，可以申請`,
    pending: `第 ${number} 點，審核中`,
    locked: `第 ${number} 點，尚未開放`,
  };

  const canOpen = state === 'claimed' || state === 'available' || state === 'pending';

  return (
    <button
      type="button"
      className={`card-point card-point--${state}`}
      aria-label={labels[state]}
      onClick={() => canOpen && onSelect(number, state)}
      disabled={!canOpen}
    >
      {state === 'claimed' && (
        <>
          <FaCheck className="card-point__check" aria-hidden="true" />
          <span className="card-point__date">{formatTaipeiMonthDay(claimedAt)}</span>
        </>
      )}
      {state === 'available' && (
        <>
          <span className="card-point__number">{number}</span>
          <span className="card-point__hint">可集點</span>
        </>
      )}
      {state === 'pending' && (
        <>
          <FaClock className="card-point__pending-icon" aria-hidden="true" />
          <span className="card-point__hint">審核中</span>
        </>
      )}
      {state === 'locked' && (
        <>
          <span className="card-point__number">{number}</span>
          <FaLock className="card-point__lock" aria-hidden="true" />
        </>
      )}
    </button>
  );
}

export default PointCircle;
